





























































import { State, Getter } from 'vuex-class';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  components: {
    PartHeader: () => import('../parts/header.vue'),
    PartFooter: () => import('../parts/footer.vue'),
    PartSidebar: () => import('../parts/sidebar.vue'),
  },
})
export default class Base extends Vue {
  @Getter('pageLoading') pageLoading!: boolean;

  @Prop({ default: false }) hasHeader!: boolean;

  @Prop({ default: false }) hasFooter!: boolean;

  @Prop({ default: false }) hasSidebar!: boolean;

  @Prop({ default: 80 }) headerHeight!: number;

  @Prop({ default: 50 }) footerHeight!: number;

  @Prop({ default: 350 }) sidebarWidth!: number;

  get hasSidebarPart() {
    return !!this.$slots.sidebar || this.hasSidebar;
  }
}
